import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  clearSettledDates() {
    document.querySelector("input[name='q[settled_at_gteq]']").value = "";
    document.querySelector("input[name='q[settled_at_lteq_end_of_day]']").value = "";
  }

  clearScheduledDates() {
    document.querySelector("input[name='q[scheduled_payment_date_gteq]']").value = "";
    document.querySelector("input[name='q[scheduled_payment_date_lteq_end_of_day]']").value = "";
  }
}
